import type { KidsPolicyItemInput, RoomDummyInput } from "@/lib/gql/__generated__/graphql";
import { CurrencyType } from "@/lib/gql/__generated__/graphql";

import type { ProductDummyRoomFormModel } from "../../../type";

type Props = {
	viewModel: ProductDummyRoomFormModel["ViewModel"];
};

export const viewModelToDummyRoomInputConverter = ({ viewModel }: Props): RoomDummyInput => {
	const input: RoomDummyInput = {
		hotelID: viewModel.hotelID,
		roomID: viewModel.roomID,

		name: viewModel.name.value,
		catchCopy: viewModel.catchCopy.value,
		description: viewModel.description.value,

		mainKeyVisual: {
			bucket: viewModel.mainKeyVisual.bucket.value,
			fileName: viewModel.mainKeyVisual.fileName?.value,
			key: viewModel.mainKeyVisual.key.value,
			mimeType: viewModel.mainKeyVisual.mimeType?.value,
			region: viewModel.mainKeyVisual.region.value,
		} satisfies RoomDummyInput["mainKeyVisual"],

		availablePlanIDs: viewModel.availablePlanIDs.value.map((item) => item.value),

		capacityAdultMaximum: viewModel.capacityAdultMaximum.value,
		capacityKidsMaximum: viewModel.capacityKidsMaximum.value,
		capacityPeopleMaximum: viewModel.capacityPeopleMaximum.value,

		maxRoomNum: viewModel.maxRoomNum.value,

		inSale: viewModel.inSale.value,

		isKidsUnavailable: viewModel.isKidsUnavailable.value,
		kidsPolicy: viewModel.kidsPolicy?.value?.length
			? viewModel.kidsPolicy.value.map((item) => {
					return {
						kidsDiscountType: item.kidsDiscountType.value,
						kidsMaxAge: item.kidsMaxAge.value,
						ratio: item.ratio?.value,
						static: {
							amount: item.static?.amount.value ?? 0,
							currencyType: item.static?.currencyType.value ?? CurrencyType.Jpy,
						},
					} satisfies KidsPolicyItemInput;
				})
			: undefined,
	} satisfies RoomDummyInput;

	return input;
};
